/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFlaskRoundPotion: {
  name: 'flask-round-potion';
  data: string;
} = {
  name: 'flask-round-potion',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 1A.5.5 0 0 1 5 .5h6a.5.5 0 0 1 0 1h-.5v3.683c1.772.898 3 2.67 3 4.817a5.5 5.5 0 1 1-11 0c0-2.147 1.228-3.919 3-4.817V1.5H5a.5.5 0 0 1-.5-.5Zm2 .5v3.989a.502.502 0 0 1-.31.474C4.744 6.598 3.707 7.897 3.528 9.5h8.944c-.18-1.603-1.216-2.902-2.662-3.537a.499.499 0 0 1-.31-.474V1.5h-3Zm-2.973 9a4.5 4.5 0 0 0 8.945 0H3.527Z" fill="currentColor"/></svg>`,
};
